export default __webpack_public_path__ + "static/media/avatar30.dd39a313.png";